module.exports = __webpack_public_path__ + "static/media/DKS-50.51c2cd76.png";